import Vue from 'vue'
import Vuex from 'vuex'
import paymentMethods from '../constants/paymentMethods'
import paymentTypes from '../constants/paymentTypes'
import payerTypes from '../constants/payerTypes'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentAmount: 60,
        paymentType: paymentTypes.SINGLE,
        paymentMethod: paymentMethods.BLIK,
        payerType: payerTypes.INDIVIDUAL,
        configData: {},
        email: '',
        firstName: '',
        lastName: '',
        corporateName: '',
        taxId: '',
        streetAddress: '',
        postalCode: '',
        city: '',
        amountList: [],
    },
    getters: {
        configData: state => {
            return state.configData
        },
        currentMethod: state => {
            return state.paymentMethod
        },
        payerType: state => {
            return state.payerType
        },
        isPaymentTypeSingle: state => {
            return paymentTypes.SINGLE === state.paymentType
        },
        amountList: state => {
            return state.amountList
        }
    },
    mutations: {
        setPayerType (state, payerType) {
            state.payerType = payerType
        },
        setPaymentType (state, paymentType) {
            state.paymentType = paymentType
        },
        setCurrentAmount (state, amount) {
            state.currentAmount = amount
        },
        setPaymentMethod (state, paymentMethod) {
            state.paymentMethod = paymentMethod
        },
        setConfigData (state, configData) {
            state.configData = configData
        },
        setEmail (state, value) {
            state.email = value
        },
        setFirstName (state, value) {
            state.firstName = value
        },
        setLastName (state, value) {
            state.lastName = value
        },
        setCorporateName (state, value) {
            state.corporateName = value
        },
        setTaxId (state, value) {
            state.taxId = value
        },
        setStreetAddress (state, value) {
            state.streetAddress = value
        },
        setPostalCode (state, value) {
            state.postalCode = value
        },
        setCity (state, value) {
            state.city = value
        },
        setAmountList (state, value) {
            state.amountList = value
        }
    }
})
